module.exports = __webpack_public_path__ + "img/turbo-features10.74891367.png";